<div
    class="agpr-quotaOverTimeChart"
    [agprLoading]="loading"
>
    <agpr-chart
        *ngIf="chart"
        [chart]="chart"
    >
    </agpr-chart>
</div>
